import { Button, Card, Col, Descriptions, Row, Spin, Statistic, Tooltip } from "antd";
import { CONSTITUTION_TYPES } from "constants/enums";
import { AUTHORITY_APPROVAL_STAGE_ID } from "constants/index";
import PropTypes from "prop-types";
import React from "react";
import "styles/case-details-summary.css";
import "styles/statistics.css";
import { formatCurrency } from "utilities/currency";
import { getKeyByValue } from "../../components/helper";
import { RECOURSE_STRUCTURE } from "../../constants";
import { CaseService, CompanyService } from "../../services";

const Description = Descriptions.Item;

const StatsCard = ({ title, duration, stats, bgColor, borderColor }) => (
    <Card
        bordered
        bodyStyle={{ padding: 5 }}
        style={{ borderRadius: 6, padding: 0, borderLeft: '2px solid', borderLeftColor: borderColor, background: bgColor }}
    >
        <Row>
            <Col span="24" className="mb-10 d-flex justify-content-space-between">
                <strong style={{ fontSize: "12px", fontWeight: 500, color: '#000' }}>{title}</strong>
                <span style={{ fontSize: "12px", fontWeight: 400 }} className="text-muted">{duration}</span>
            </Col>

            <Col span="24" className="mb-10">
                {stats.map(({ label, value, danger }, index) => (
                    <Col md={4} sm={6} xs={6} key={label}>
                        <div style={{ fontSize: "11px" }} className="text-muted">{label}</div>
                        <p style={{ fontSize: "11px", fontWeight: 500, color: "#000", marginBottom: index < 4 ? 10 : 0 }} className={danger ? 'text-danger' : ''}>
                            {value} {danger && '⚠'}
                        </p>
                    </Col>
                ))}
            </Col>
        </Row>
    </Card>
);

class FoundersCaseDetailsSummary extends React.Component {

    state = {
        getBuyerExposureDataV2: [],
        approverDetails: [],
        approverDetailsV2: {},
        isApproved: {},
        loading: false,
        buyerExposureData: [],
        buyerExposureLoader: true,
        caseCategory: 0,
        activeLimitInfoFilter: ''
    }

    fetchApprovalDetails = () => {
        CaseService.getApprovalDetails(this.props.caseId)
            .then(({ data }) => {
                let obj = {};
                data.map(_ => {
                    obj[_.name] = _
                })
                this.setState({
                    approverDetails: data,
                    approverDetailsV2: obj
                })

            })
    }

    componentDidMount() {
        if (this.props.stageId == AUTHORITY_APPROVAL_STAGE_ID) {
            this.fetchApprovalDetails();
        }

        CompanyService.getBuyerExposure(this.props.caseId).then(res => {

            const data = res.data?.message;
            const objectKeys = Object.keys(data);
            const objectItemKeys = data[objectKeys[0]];
            let tableData = [];
            Object.keys(objectItemKeys).map(_ => {
                let eachItem = objectKeys.map(dataKey => {
                    return {
                        [dataKey]: data[dataKey][_]
                    };
                });
                tableData.push({
                    "name": _.split("_").join(" ").replace(/\b\w/g, function (m) { return m.toUpperCase(); }),
                    ...Object.assign({}, ...eachItem),
                });
            });
            this.setState({
                getBuyerExposureDataV2: Object.entries(data).map(([key, value]) => ({
                    ...value,
                    type_2: key
                }))
            });
        })
            .catch(res => {
                console.log("inside catch", res, res && Object.values(res)[0]);
            });


        CompanyService.getCaseBuyerExposure(this.props.caseId).then((res) => {
            this.setState({ buyerExposureData: res?.data?.data, buyerExposureLoader: false });
        })
            .catch((error) => {
                this.setState({ buyerExposureLoader: false })
            });

        CaseService.getCaseCategoryTag(this.props.caseId).then((res) => {
            if (res.data && res.data.case_category !== undefined) {
                this.setState({
                    caseCategory: res.data.case_category,
                });
            }
        })
            .catch((error) => {
                console.log("error message:", error.message);
            })
    }

    getValue = val => {
        return (
            <React.Fragment>
                <span>{val && val.split("|")[0]}</span>
                <span style={{
                    color: "#f9f9f9",
                }}>{` (${val && val.split("|")[1]})`}</span>
            </React.Fragment>
        );
    }
    getValueAnchor = (tooltipTitle) => {
        let tooltipList;
        let hoverTitle = tooltipTitle;
        if (this.props.caseId === 130090) {
            tooltipList = tooltipTitle.split(",").map(item =>
                item.replace(/\s*\([^)]*\)/g, '').replace(/\d+$/, '').trim()
            );
            hoverTitle = '';
        } else {
            tooltipList = tooltipTitle.split(",").map(item => item.trim());
        }

        return (
            <React.Fragment>
                <span title={hoverTitle}>
                    <div>
                        {tooltipList.map((_, index) => (
                            <div key={index}>{_}</div>
                        ))}
                    </div>
                </span>
            </React.Fragment>
        );
    }
    getValueSeller = (tooltipTitle) => {
        let tooltipList;
        let hoverTitle = tooltipTitle;
        if (this.props.caseId === 130090) {
            tooltipList = tooltipTitle.split(",").map(item =>
                item.replace(/\s*\([^)]*\)/g, '').replace(/\d+$/, '').trim()
            );
            hoverTitle = '';
        } else {
            tooltipList = tooltipTitle.split(",").map(item => item.trim());
        }
        return (
            <React.Fragment>
                <span title={hoverTitle}>

                    <div>
                        {tooltipList.map((_, index) => (
                            <div key={index}>{_}</div>
                        ))}
                    </div>
                </span>
            </React.Fragment>
        );
    }
    get_anchors_user_view = () => {
        const { anchors_list, data } = this.props;
        let anchors = (this.props.supply_chain_anchor && this.props.supply_chain_anchor.length) ? this.props.supply_chain_anchor : this.props.data.get('anchors')
        const tooltipContent = anchors.map(_ => _.name + (_.is_anchor_aligned ? "(Aligned)" : "(Not Aligned)") + _.id).join(', ');
        return tooltipContent;

    }

    get_sellers_user_view = () => {
        const { sellers_list, data } = this.props;
        let sellers = (this.props.supply_chain_seller && this.props.supply_chain_seller.length) ? this.props.supply_chain_seller : this.props.data.get('sellers')
        const sellerTooltipContent = sellers.map(_ => _.name + (_.is_anchor_aligned ? "(Aligned)" : "(Not Aligned)") + _.id).join(', ');
        return sellerTooltipContent;
    }

    fieldCard = (key, field) => {
        return <Col xs={12} sm={12} md={8} lg={4} style={{ marginBottom: 10 }}>
            <Statistic
                title={<span style={{ fontSize: 12 }}>{field.label}</span>}
                value={field.value}
                className="compact-stat"
                valueStyle={{
                    fontSize: 12,
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                }}
                style={{
                    height: 47,
                    background: "#fff",
                    border: '1px solid #edeef1',
                    padding: '0px 12px',
                    borderRadius: 4,
                    marginRight: 10

                }}
            />
        </Col>
    }


    caseProfile = () => {
        console.log("this.props.risk_sharing_percentage", this.props.risk_sharing_percentage);
        const { data, proposed_limit } = this.props;
        var addresses = this.props.company && this.props.company.get('addresses').toList().filter(_ => _.address_type == 1);
        let anchor_tooltip = this.get_anchors_user_view();
        let seller_tooltip = this.get_sellers_user_view();
        let sellerRisk = this.props.risk_sharing_percentage.map((_, i, arr) => (
            _.recourse_structure && _.status != "Signed" ? `${getKeyByValue(RECOURSE_STRUCTURE, _.recourse_structure)}  ${_.security_perc || 0}%  -  ${_.seller}` : !_.risk_sharing_perc ? `${_.status +" - " +  _.seller}`: `${_.risk_sharing_perc}% + " - " ${_.seller}` 
        ))
        console.log("sellerRisksellerRisksellerRisk", sellerRisk)
        const CASE_PROFILE_MOCK_DATA = {
            title: "CASE PROFILE",
            fields: [
                { id: '1', label: "Industry", value: data.get('industry') },
                { id: '2', label: "Anchor", value: anchor_tooltip },
                { id: '3', label: "Seller", value: seller_tooltip },
                { id: '4', label: "State", value: (addresses && addresses.size) ? addresses.first().getIn(['state', 'name'], '--') : "--" },
                { id: '5', label: "City", value: (addresses && addresses.size) ? addresses.first().getIn(['city', 'name'], '') : '--' },
                { id: '6', label: "Case Proposed Limit", value: formatCurrency(proposed_limit, true), variant: 'highlight' },
                { id: '7', label: "Seller Risk %", value: sellerRisk.join('\n')},
                { id: '8', label: "Case Type", value: data?.case_type_sanctioned || "--" },
                { id: '9', label: "Bank", value: data?.bank?.code || "--" },
                { id: '10', label: "Constitution", value: this.props.company ? CONSTITUTION_TYPES.findKey(_ => _ === this.props.company.constitution) : '--' },
            ]
        };
        return <Row>
            <div
                className="card border shadow-lg rounded-4 p-2 p-md-5"
                style={{ backgroundColor: '#FEFBF6', borderColor: '#e5e7eb' }}
            >
                <div className="mb-5">
                    <span className="fw-600 font_14" style={{ color: "#617084" }}>CASE PROFILE</span>
                </div>
                <div className="row g-3">
                    {CASE_PROFILE_MOCK_DATA.fields.map((field) => (
                        this.fieldCard(field.id, field)
                    ))}
                </div>
            </div>
        </Row>
    }

    renderLimitInfoFilter = () => {
        const { buyerExposureData, activeLimitInfoFilter } = this.state;
        const filters = buyerExposureData ? buyerExposureData.map(_ => _.business_product_type) : [];
        return (
            <Row className="mb-10">
                {filters.map((_, index) => (
                    <Button
                        key={_}
                        style={{ color: activeLimitInfoFilter === _ ? '#fff' : '#617084', paddingLeft: 5 }}
                        type={activeLimitInfoFilter === _ ? 'primary' : 'link'}
                        onClick={() =>
                            this.setState({ activeLimitInfoFilter: _ })
                        }
                    >
                        {_}
                    </Button>
                ))}
            </Row>
        );
    };


    renderLimitInfoCard = () => {
        const data = this.state.buyerExposureData ? this.state.buyerExposureData.filter(_ => _.business_product_type == this.state.activeLimitInfoFilter) : [];
        const LIMIT_INFO_MOCK_DATA = {
            title: "CASE PROFILE",
            fields: this.state.activeLimitInfoFilter == '' ? [] : [
                { id: '1', label: "Product Type", value: data[0].business_product_type },
                { id: '2', label: "Sanctioned Limit", value: data[0].sanction_limit },
                { id: '3', label: "Adhoc Limit", value: data[0].adhoc_limit },
                { id: '4', label: "Current OS", value: data[0].total_receivable },
                { id: '5', label: "# Churn", value: data[0].churn },
                { id: '6', label: "% OD invoices", value: data[0].od_invoices },
                { id: '7', label: "Max DPD LTM", value: data[0].max_dpd_12m },
                { id: '8', label: "% OD>30 dpd LTM", value: data[0].prcn_od_30_ltm_invoices },
                { id: '9', label: "Group limit", value: data[0].group_limit },
            ]
        };

        return <Card bodyStyle={{ padding: "10px 15px" }} style={{ borderLeft: "2px solid #0ca2e8", borderRadius: 7, background: "#f6ebff" }}>
            <Spin spinning={this.state.buyerExposureLoader}>
                <Row>
                    <Col lg={24} sm={12}>
                        <p className="fw-600 mb-5 font_14" style={{ color: "#617084" }}>EXISTING LIMIT INFO</p>
                        {this.renderLimitInfoFilter()}
                    </Col>
                    <Col lg={24} xs={24} sm={24}>
                        <div className="row g-3">
                            {data.length ? LIMIT_INFO_MOCK_DATA.fields.map((field) => (
                                this.fieldCard(field.id, field)
                            )) : <p>No existing credit limit found for this customer.</p>}
                        </div>

                    </Col>
                </Row>
            </Spin>
        </Card>
    }

    portfolioView = () => {
        return <Card bodyStyle={{ padding: "10px 15px" }} style={{ borderRadius: 7, borderLeft: "2px solid #f59f0b", background: "#faf6ef" }}>
            <Row>
                <Col lg={24} sm={24}>
                    <p className="fw-600 font_14" style={{ color: "#617084" }}>PORTFOLIO VIEW</p>
                </Col>
                <Col lg={24} xs={24} sm={24} >
                    {this.props.portfolioViewData ? this.props.portfolioViewData.map((_, index) => {
                        if (_.category == "RBH") {
                            return null
                        }
                        return <Col lg={8} xs={24} sm={24} style={{ marginBottom: 8 }}>
                            <StatsCard
                                title={_.category}
                                duration={_.vintage}
                                stats={[
                                    { label: 'Customers', value: _.customers || '-' },
                                    { label: '% Active', value: `${_.activePercent}%` || '-' },
                                    { label: 'PAR 0', value: _.par0 || '-', danger: true },
                                    { label: 'PAR 30', value: _.par30 } || '-',
                                    { label: 'PAR 90', value: _.par90 || '-' },
                                    { label: 'Throughput', value: _.throughput || '-' },
                                    { label: 'AUM', value: _.aum || '-' },
                                    { label: 'Profit', value: _.profitability || '-' },
                                ]}
                                bgColor={['#f1f3e8', "#f0f1ef", "#f9f1e6"][index]}
                                borderColor={["#52c41a", "#68baeb", "#f8b861"][index]}
                            />
                        </Col>
                    }) : <p>We’re unable to fetch the data at the moment. Please try again shortly.</p>}

                </Col>
            </Row>
        </Card>
    }

    render() {
        console.log("in renderrrrr")
        let product_type_dropdown = [
            { id: 1, value: "Invoice Finance" },
            { id: 2, value: "Vendor Finance" },
            { id: 3, value: "Working Capital Demand Loan" },
            { id: 5, value: "Purchase Invoice Finance" },
            { id: 6, value: "Sales Invoice Finance" },
            { id: 8, value: "Personal Term Loan" },
            { id: 9, value: "Short Term Loan (STL)" },
        ]
        if (this.props.data.scheme_type == "Vendor Finance") {
            product_type_dropdown = product_type_dropdown.filter((_) => [2].includes(_.id))
        } else if (this.props.data.scheme_type == "Term Loan") {
            product_type_dropdown = product_type_dropdown.filter((_) => [3, 8, 9].includes(_.id))
        } else if (["Default Scheme", "Combinational Scheme", "Rff Level Scheme", "Per Unit Subvention Scheme", "Subvention Basis Invoice Date"].includes(this.props.data.scheme_type)) {
            product_type_dropdown = product_type_dropdown.filter((_) => [1, 5, 6].includes(_.id))
        } else {
            product_type_dropdown = []
        }
        const { anchors_list, sellers_list } = this.props;
        return (
            <React.Fragment>
                {this.caseProfile()}
                {![130090, 141834].includes(this.props.caseId) && <>
                    <span style={{ display: "block", height: 15 }}></span>
                    {this.renderLimitInfoCard()}
                </>}
                <span style={{ display: "block", height: 15 }}></span>
                {![130090, 141834].includes(this.props.caseId) && this.portfolioView()}
            </React.Fragment>
        );
    }
}

FoundersCaseDetailsSummary.propTypes = {
    companyId: PropTypes.number,
    caseId: PropTypes.number,
    seller: PropTypes.string,
    anchor: PropTypes.string,
    batch: PropTypes.string,
    bank: PropTypes.string,
    salesManager: PropTypes.string,
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    product: PropTypes.string,
    stagePermissions: PropTypes.object,
    stageId: PropTypes.number,
    data: PropTypes.object,
    isInbox: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
    stageName: PropTypes.string,
    viewCaseNotes: PropTypes.func,
    proposed_limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tenor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stop_billing_days: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    scheme_roi: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    anchors_list: PropTypes.array,
    sellers_list: PropTypes.array,
    casesList: PropTypes.object,
    existing_limit: PropTypes.number,
    permissions: PropTypes.object,
    company: PropTypes.object,
    portfolioViewStatus: PropTypes.string,
    portfolioViewData: PropTypes.func,
    risk_sharing_percentage: PropTypes.object
};

export default FoundersCaseDetailsSummary;
